/**
 * @license
 * Copyright 2020 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

 import './select_view.less';

 import {WatchableValueInterface} from 'neuroglancer/trackable_value';
 import {RefCounted} from 'neuroglancer/util/disposable';
 import {MakeIconOptions} from 'neuroglancer/widget/icon';
 import svg_down from 'neuroglancer/static/down.svg';
 import {TrackableBoolean } from 'neuroglancer/trackable_boolean';
import { viewer } from 'src/main';
 
 export interface MakeCheckboxIconOptions extends Omit<MakeIconOptions, 'onClick'|'title'> {
   enableTitle?: string;
   disableTitle?: string;
   backgroundScheme?: 'light' | 'dark';
   defaultValue?: string;
   defaultTitle?: string;
   childElement?: HTMLElement,
   classes?: Array<string>,
   disabled?: boolean,
   onClick?: Function
 }
 
 export class SelectView extends RefCounted {
   readonly element: HTMLElement;
   localDrop = new TrackableBoolean(false, false);
   model: WatchableValueInterface<boolean>;
   childElement: HTMLElement;
   disabled = new TrackableBoolean(false, false);
   showlabel: HTMLElement;
   options: MakeCheckboxIconOptions;
   constructor(model: WatchableValueInterface<boolean> | null, options: MakeCheckboxIconOptions) {
    super();
    // this.element = makeIcon({
    // ...options,
    // onClick: () => {
    // model.value = !model.value;
    // },
    // });
    if (model) this.model = model;
    if (options) this.options = options;
    const {onClick} = options
    this.element = document.createElement('div')
    this.element.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      if (this.disabled.value) return
      if (this.element.classList.contains('lasso_disabled')) return
      if (model) {
        model.value = !model.value;
      } else {
        this.localDrop.value = !this.localDrop.value
        updateView();
      }
      if(!this.localDrop.value){
        if(classes?.includes('gene-view') && document.getElementsByClassName('default-color-image-user-layer')[0]){
          // 关闭genetable相关的dialog
          viewer.configDialog?.close();
          viewer.clearActiveTool();
          viewer.selectedLayer.layer = undefined;
        }else if( (classes?.includes('layer-view') || classes?.includes('tools-setting') )&& 
        document.getElementsByClassName('can_zoom_move_container')[0] && 
        document.getElementsByClassName('can_zoom_move_container_unique')[0] && 
        (!document.getElementsByClassName('default-color-image-user-layer')[0] || viewer.selectedLayer?.layer?.genetype.includes('proteinimage_image')) ){
          // 关闭layer相关的dialog
          viewer.configDialog?.close();
          viewer.clearActiveTool();
          viewer.selectedLayer.layer = undefined;
        }else{
          if(classes?.includes('cluster-view') && document.getElementsByClassName('cluster-view')[0].children.length > 1){
            const dom = document.getElementsByClassName('cluster-view')[0];
            for(let i = 1; i < dom.children.length; i++){
              document.getElementsByClassName('cluster-view')[0].removeChild(dom.children[i]);
            }
          }
        }
      }else{
        if(classes?.includes('cluster-view') && document.getElementsByClassName('cluster-view')[0].children.length > 1){
          document.getElementsByClassName('cluster-view')[0].removeChild(document.getElementsByClassName('neuroglancer-segment-display-tab')[0])
        }
      }
      if (onClick) onClick(model ? model.value : this.localDrop.value)
    });
    
    const {defaultValue, childElement, classes, defaultTitle} = options
    this.element.classList.add(...(classes ?? []));
    this.element.classList.add('neuroglancer-selecteView');
    this.element.classList.add(
    (options.backgroundScheme === 'dark') ? 'dark-background' : 'light-background');

    // if (disabled) {
    //   this.element.classList.add('disabled')
    // }
    
    const labelContainer = document.createElement('div')
    labelContainer.classList.add('selecte-views-label')

    const text = this.showlabel = document.createElement('div')
    text.classList.add('selecte-text')
    if (defaultValue) {
        text.innerHTML = defaultValue
    }
    if(defaultTitle){
      text.title = defaultTitle;
    }
    // this.element.appendChild(text)
    labelContainer.appendChild(text)

    const span = document.createElement('div')
    span.classList.add('down-icon')
    span.innerHTML = svg_down
    // this.element.appendChild(span)
    labelContainer.appendChild(span)
    this.element.appendChild(labelContainer)

    if (childElement) {
        childElement.className = 'selecte-views-options'
        this.element.appendChild(childElement)
        this.childElement = childElement
        this.childElement.addEventListener('click', (e) => {
          e.stopPropagation()
        })
    }
    const updateView = () => {
      const value = model ? model.value : this.localDrop.value;
      this.element.dataset.checked = value ? 'true' : 'false';
      labelContainer.title = (value ? options.disableTitle : options.enableTitle) || '';
      if (this.disabled.value) {

      }
      this.element.classList[this.disabled.value ? 'add' : 'remove']('disabled');
    };
    if (model) {
      this.registerDisposer(model.changed.add(updateView));
    } else {
      this.registerDisposer(this.localDrop.changed.add(updateView));
    }
    this.registerDisposer(this.disabled.changed.add(updateView))
    updateView();
   }

   setDisable (val: boolean) {
    this.disabled.value = val
   }
   setLabel (val: string = '') {
    this.showlabel.innerHTML = val
   }
   setState (val: boolean) {
    if (this.model) {
      this.model.value = val
    } else {
      this.localDrop.value = val
    }
   }
   close(){
    this.localDrop.value = !this.localDrop.value
    const value = this.model ? this.model.value : this.localDrop.value;
    this.element.dataset.checked = value ? 'true' : 'false';
    (document.getElementsByClassName('selecte-views-label')[0] as HTMLElement).title = (value ? this.options.disableTitle : this.options.enableTitle) || '';
    this.element.classList[this.disabled.value ? 'add' : 'remove']('disabled');
   }
 }
